export const JOB_TITLE_MAX_LENGTH = 255;
export const JOB_DESCRIPTION_MIN_LENGTH = 10;
export const JOB_DESCRIPTION_MAX_LENGTH = 2500;
export const JOB_CONTACT_EMAIL_MAX_LENGTH = 255;
export const JOB_CONTACT_PHONE_MAX_LENGTH = 50;
export const JOB_COMPANY_NAME_MAX_LENGTH = 255;
export const JOB_LOCATION_ADDRESS_MAX_LENGTH = 255;
export const JOB_TAG_NAME_MAX_LENGTH = 255;
export const JOB_EXTERNAL_ID_MAX_LENGTH = 255;
